import api from '../../../_metronic/helpers/api'
import {stringify} from 'qs'
import {useDispatch} from 'react-redux'
import {showAlert} from '../../redux/reducers/alertSlice'
import CryptoJS from 'crypto-js'
function useUtils() {
  const dispatch = useDispatch()
  const key = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_KEY || '')
  const iv = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_IV || '')
  const fetchUsers = async (
    text = null,
    order = null,
    type = null,
    selectedType = null,
    subscription = null,
    date = null,
    limit = 10,
    offset = 0
  ) => {
    try {
      const params = {
        limit,
        offset,
        relations: ['subscription'],
        order: {createdAt: 'DESC'},
        where: {},
      }

      if (text) {
        params.text = text
      }

      if (selectedType && type !== 'State') {
        params.where.isActive = selectedType
      }

      if (type && type !== 'Type') {
        params.where.isSubscribed = type
      }

      if (subscription && subscription !== 'Subscription') {
        params.where.subscriptionId = subscription
      }

      if (date && date[0] !== null) {
        params.lastLoginStartDate = date[0].getTime()
        params.lastLoginEndDate = date[1].getTime()
      }

      if (order) {
        params.order = {totalReferrals: order}
      }

      const response = await api.get(`/user?${stringify(params)}`)
      if (response.data.status) {
        return response.data.data
      }
    } catch (error) {
      console.error(error)
    }
  }

  const fetchUser = async (id) => {
    try {
      const params = {
        relations: ['subscription'],
      }

      const response = await api.get(`/user/${id}?${stringify(params)}`)
      if (response.data.status) {
        return response.data.data
      }
    } catch (error) {
      console.error(error)
    }
  }

  const fetchAllUsers = async (
    text = null,
    order = null,
    type = null,
    selectedType = null,
    subscription = null,
    date = null
  ) => {
    const params = {
      limit: 100,
      offset: 0,
      order: {createdAt: 'DESC'},
      where: {},
    }

    if (text) {
      params.text = text
    }

    if (selectedType && type !== 'State') {
      params.where.isActive = selectedType
    }

    if (type && type !== 'Type') {
      params.where.isSubscribed = type
    }

    if (subscription && subscription !== 'Subscription') {
      params.where.subscriptionId = subscription
    }

    if (date && date[0] !== null) {
      params.lastLoginStartDate = date[0].getTime()
      params.lastLoginEndDate = date[1].getTime()
    }

    if (order) {
      params.order = {totalReferrals: order}
    }

    let allData = []
    let totalRecords = 0

    try {
      const initialResponse = await api.get(`/user?${stringify(params)}`)
      if (initialResponse.data.status) {
        totalRecords = initialResponse.data.data.count
        allData = initialResponse.data.data.records

        const totalChunks = Math.ceil(totalRecords / params.limit)
        const promises = []

        for (let i = 1; i < totalChunks; i++) {
          params.offset = i * params.limit
          promises.push(api.get(`/user?${stringify(params)}`))
        }

        const responses = await Promise.all(promises)
        responses.forEach((response) => {
          if (response.data.status) {
            allData = [...allData, ...response.data.data.records]
          }
        })

        if (allData.length > 0) {
          return allData.map((record) => ({
            id: record?.id,
            name: record?.name,
            email: record?.email,
            password: CryptoJS.AES.decrypt(record?.password, key, {
              iv: iv,
              mode: CryptoJS.mode.CBC,
              padding: CryptoJS.pad.Pkcs7,
            }).toString(CryptoJS.enc.Utf8),
            isPremiumUser: record?.isPremiumUser == true,
            subscriptionId: record?.subscriptionId || null,
            blackForceMember: record?.blackForceMember == true,
          }))
        }
      }
    } catch (error) {
      console.log(error)
      dispatch(
        showAlert({
          message: error?.response?.data?.message || 'Network error',
          variant: 'danger',
        })
      )
    }
  }

  const addCSV = async (data) => {
    try {
      const response = await api.post(`/user/add-bulk`, data)
      if (response?.data?.status) {
        return response?.data?.data
      }
    } catch (error) {
      dispatch(
        showAlert({
          message:
            error?.response?.data?.details[0]?.message ||
            error?.response?.data?.message ||
            'Network error',
          variant: 'danger',
        })
      )
    }
  }

  const fetchSubscriptions = async () => {
    const params = {
      returnAllRecords: true,
      offset: 0,
      where: {
        isActive: true,
      },
    }

    try {
      const response = await api.get(
        `/subscription?${stringify(
          params
        )}&select[name]=true&select[id]=true&select[createdAt]=true&order[name]=ASC`
      )
      if (response.data.status) {
        return response.data.data.records
      }
    } catch (error) {
      console.log(error?.message)
    }
  }

  const submitReport = async (data) => {
    try {
      const response = await api.post(`/setting/sendCSVReport`, data)
      return response
    } catch (error) {}
  }

  return {
    fetchUsers,
    fetchUser,
    fetchSubscriptions,
    addCSV,
    fetchAllUsers,
    submitReport,
  }
}

export default useUtils
